import Joi from 'joi';

import { FormValues } from './types';
import { requiredString } from '../../../../../../../../utils/validators';

export const validationSchema = Joi.object<FormValues, true>({
  selectedClassId: requiredString,
});
